
import { defineComponent, PropType, ref, watchEffect } from "vue";

export default defineComponent({
  name: "ConnectorView",
  components: {},
  emits: ["radioChange"],
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    connectorInfo: {
      type: Object as PropType<{ connectors: number; edges: number }>,
      required: true,
      default: () => ({ connectors: 0, edges: 0 }),
    },
  },

  // setup function
  setup(props, { emit }) {
    const currentSelection = ref("");

    const woodValues = ref([
      "3/4” (19.05 mm)",
      "1/2” (12.7 mm)",
      "1/4” (6.35 mm)",
    ]);

    const pvcValues = ref(["3/4” (19.05 mm)", "1/2” (12.7 mm)"]);

    watchEffect(() => {
      emit("radioChange", currentSelection.value);
    });

    return {
      currentSelection,
      woodValues,
      pvcValues,
    };
  },
});
